const MAX_FILE_SIZE = 2097152; // 2MB

export interface ISelectedFile {
  [key: string]: File | undefined;
}

interface ErrorHandler<T> {
  setError?: (field: T, error: { message: string }) => void;
  clearErrors?: (field: T) => void;
}

const byteToMb = Math.floor(MAX_FILE_SIZE / 1024 / 1024);

export const useFileChangeHandler = <T extends string>(
  setState: React.Dispatch<React.SetStateAction<ISelectedFile>>,
  errorHandlers: ErrorHandler<T> = {},
  { maxSize = MAX_FILE_SIZE, isSkipSizeCheck = false } = { maxSize: MAX_FILE_SIZE }
) => {
  return async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name: _name } = e.target;
    const name = _name as T;
    console.log("🚀 [Debug] ~ return ~ name:", name)
    const _setState = (val: File | undefined) => {
      setState((prev) => ({
        ...prev,
        [name]: val,
      }));
    }
    
    if (!e.target.files || e.target.files.length === 0) {
      _setState(undefined);
      return;
    }

    const file = e.target.files[0];
    // Validate Size
    if (!isSkipSizeCheck && file.size > maxSize) {
      errorHandlers.setError?.(name, {
        message: `File is bigger than ${byteToMb}MB`,
      });
      _setState(undefined);
      return;
    }
    errorHandlers.clearErrors?.(name);
    _setState(file);
  };
};
